import React, { Component } from 'react';

export default function asyncComponent(importComponent) {
  let cachedPromise = null;
  const load = () => {
    if (!cachedPromise) {
      cachedPromise = importComponent().catch(error => {
        cachedPromise = null;
        throw error;
      });
    }
    return cachedPromise;
  };

  class AsyncComponent extends Component {
    state = { component: null };

    componentDidMount() {
      this._isMounted = true;
      load()
        .then(({ default: component }) => {
          sessionStorage.removeItem('chunkReloaded');
          if (this._isMounted) this.setState({ component });
        })
        .catch(error => {
          const message = (error && (error.message || error.name)) || '';
          if (/Loading chunk|ChunkLoadError/i.test(message) && !sessionStorage.getItem('chunkReloaded')) {
            sessionStorage.setItem('chunkReloaded', '1');
            window.location.reload();
          }
        });
    }

    componentWillUnmount() {
      this._isMounted = false;
    }

    render() {
      const C = this.state.component;
      return C ? <C {...this.props} /> : null;
    }
  }

  AsyncComponent.preload = load;
  return AsyncComponent;
}
